// extracted by mini-css-extract-plugin
export default {"header":"Header_header__qG3wv","move-text-color":"Header_move-text-color__cwuqH","header_text":"Header_header_text__+V3DT"};